import service from '@/api/deployment/application';
import {handleError} from '@/state/generators/helpers';
import {alert} from "../../generators/helpers";

export const state = {
    loadingInstall: false,
    service: service('deployments/applications'),
}

export const getters = {
    loadingInstall: (state) => {
        return !!state.loadingInstall;
    }
}

export const mutations = {
    'SET_LOADING_INSTALL': function (state, boolean = true) {
        state.loadingInstall = boolean;
    }
}

export const actions = {
    install: function ({commit, state}, data) {
        commit('SET_LOADING_INSTALL', true);

        return state.service.install(data).then(instance => {
            commit('SET_LOADING_INSTALL', false);
            alert(commit, this.$t('deployments::applications.install_info'));
            return instance;
        }).catch((e) => {
            commit('SET_LOADING_INSTALL', false);
            handleError(e, commit);
        });
    }
}
